<div *ngIf="questionnaire">
  <app-questionniare-summary [questionnaire]="questionnaire" [questionnaireId]="questionnaire.id"
                             [waterSystemId]="waterSystemId" [siteVisitId]="siteVisitId"
                             [isQuestionnaireCollapsed]="isCollapsed"></app-questionniare-summary>
</div>
